<!-- -------------------------------------------------------------------------- -->
<!--                          ANCHOR CABECERA DE SECCION                        -->
<!-- -------------------------------------------------------------------------- -->

<div class="z-page-head z-rise">
  <div>
    <h1 class="z-page-title">Programa</h1>
    <p class="z-page-subtitle">
      ¿El programa está sano? La entregabilidad de la base de contactos y el vocabulario
      común del NPS.
    </p>
  </div>

  <div class="z-page-actions">
    <button class="z-btn z-btn--glass" type="button" (click)="descargar()">
      <i class="bi bi-download" aria-hidden="true"></i> Descargar CSV
    </button>
  </div>
</div>

<!-- El glosario es un documento de referencia: no depende del periodo ni de la
     sucursal, asi que la barra de filtros solo acompaña a Entregabilidad. -->
@if (tab === 'entregabilidad') {
  <app-filter-bar [fields]="filtros"
                  [selected]="seleccion"
                  (selectedChange)="onFiltros($event)" />
}

<app-section-tabs [tabs]="tabs" [(active)]="tab" />

@switch (tab) {

  <!-- ---------------------------------------------------------------------- -->
  <!--                        ANCHOR ENTREGABILIDAD                           -->
  <!-- ---------------------------------------------------------------------- -->

  @case ('entregabilidad') {
    <div class="prog-tab" role="tabpanel" aria-labelledby="z-tab-entregabilidad">

      <section class="z-panel z-rise z-rise-1">
        <header class="z-panel-head">
          <div>
            <h2 class="z-panel-title">Embudo de entregabilidad</h2>
            <p class="z-panel-hint">
              De los registros recibidos a las encuestas efectivas. La barra de cada fila
              solo insinúa su magnitud; la cifra exacta está en las columnas.
            </p>
          </div>
        </header>

        <div class="z-panel-body">
          <div class="z-table-wrapper">
            <table class="z-table funnel-table">
              <thead>
                <tr>
                  <th class="th-teal" scope="col">Estatus</th>
                  <th class="th-teal" scope="col">Total</th>
                  <th class="th-teal" scope="col">%</th>
                </tr>
              </thead>
              <tbody>
                @for (fila of embudo; track fila.estatus) {
                  <tr [style.--z-funnel-w]="anchoBarra(fila)">
                    <td class="funnel-status">{{ fila.estatus }}</td>
                    <td class="z-cell-center">{{ fila.total | number }}</td>
                    <td class="z-cell-center funnel-share">{{ fila.porcentaje }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section class="z-panel z-rise z-rise-2">
        <header class="z-panel-head">
          <div>
            <h2 class="z-panel-title">Envíos por día y canal</h2>
            <p class="z-panel-hint">SMS, Mail y WhatsApp, día por día.</p>
          </div>
        </header>

        <div class="z-panel-body">
          <app-chart [options]="enviosPorCanal" [height]="340" />
        </div>
      </section>

    </div>
  }

  <!-- ---------------------------------------------------------------------- -->
  <!--                           ANCHOR GLOSARIO                              -->
  <!-- ---------------------------------------------------------------------- -->

  @case ('glosario') {
    <div class="prog-tab" role="tabpanel" aria-labelledby="z-tab-glosario">

      <section class="z-panel z-rise z-rise-1">
        <header class="z-panel-head">
          <div class="gloss-id">
            <span class="z-pill-icon"><i class="bi bi-journal-text" aria-hidden="true"></i></span>
            <div>
              <h2 class="z-panel-title">{{ documento }}</h2>
              <p class="z-panel-hint">{{ nota }} · {{ terminos.length }} términos</p>
            </div>
          </div>

          <div class="z-panel-actions">
            <label class="z-sr-only" for="gloss-search">Buscar término del glosario</label>

            <div class="z-search gloss-search">
              <i class="bi bi-search" aria-hidden="true"></i>
              <input id="gloss-search"
                     type="search"
                     autocomplete="off"
                     placeholder="Buscar término…"
                     [(ngModel)]="busqueda"
                     (ngModelChange)="filtrar()" />

              @if (busqueda) {
                <button class="z-icon-btn"
                        type="button"
                        aria-label="Limpiar la búsqueda"
                        (click)="limpiarBusqueda()">
                  <i class="bi bi-x-lg" aria-hidden="true"></i>
                </button>
              }
            </div>
          </div>
        </header>

        <div class="z-panel-body">
          <p class="z-sr-only" role="status">
            {{ visibles.length }} de {{ terminos.length }} términos
          </p>

          @if (visibles.length) {
            <dl class="gloss-grid">
              @for (item of visibles; track item.termino) {
                <div class="gloss-item">
                  <dt class="gloss-term">{{ item.termino }}</dt>
                  <dd class="gloss-def">{{ item.definicion }}</dd>
                </div>
              }
            </dl>
          } @else {
            <div class="z-empty">
              <i class="bi bi-search" aria-hidden="true"></i>
              <p>Ningún término coincide con «{{ busqueda }}».</p>
              <button class="z-btn z-btn--glass" type="button" (click)="limpiarBusqueda()">
                <i class="bi bi-arrow-counterclockwise" aria-hidden="true"></i>
                Ver los {{ terminos.length }} términos
              </button>
            </div>
          }
        </div>
      </section>

    </div>
  }
}
